import dayjs from 'dayjs'

/** "2h ago" / "3d ago" / "Jun 4" — used on album cards and hero meta lines. */
export function formatRelative(iso?: string): string | null {
  if (!iso) return null
  const d = dayjs(iso)
  if (!d.isValid()) return null
  const mins = Math.max(0, dayjs().diff(d, 'minute'))
  if (mins < 1) return 'just now'
  if (mins < 60) return `${mins}m ago`
  const hours = dayjs().diff(d, 'hour')
  if (hours < 24) return `${hours}h ago`
  const days = dayjs().diff(d, 'day')
  if (days < 30) return `${days}d ago`
  return d.format('MMM D')
}

/** "2M" / "3H" / "5D" — compact mono timestamp used next to comment authors. */
export function formatCompactRelative(iso?: string): string {
  if (!iso) return ''
  const d = dayjs(iso)
  if (!d.isValid()) return ''
  const mins = Math.max(0, dayjs().diff(d, 'minute'))
  if (mins < 1) return 'NOW'
  if (mins < 60) return `${mins}M`
  const hours = dayjs().diff(d, 'hour')
  if (hours < 24) return `${hours}H`
  const days = dayjs().diff(d, 'day')
  if (days < 30) return `${days}D`
  return d.format('MMM D').toUpperCase()
}

/** "JUN 2026" — used in card stat rows. */
export function formatMonthYear(iso?: string): string | null {
  if (!iso) return null
  const d = dayjs(iso)
  if (!d.isValid()) return null
  return d.format('MMM YYYY').toUpperCase()
}
